declare global {
    interface String {
        toSnakeCase(): string;
    }
}

String.prototype.toSnakeCase = function() {
    return this.toLowerCase().replace(/\s+/g, '_');
};

export {};